
    import Vue from 'vue';
    import { EventEnum, ModalEnum } from '@/types/events';
    import { logger } from '@/util/logger';
    export default Vue.extend({
        name: 'ModalPresenter',
        components: {
            // TODO handle the loading state: https://vuejs.org/v2/guide/components-dynamic-async.html#Handling-Loading-State
            [ModalEnum.Deny]: () => import(/* webpackChunkName: "modal.deny"*/ '@/components/Modals/Deny.vue'),
            [ModalEnum.Faq]: () => import(/* webpackChunkName: "modal.faq", webpackPrefetch: true  */ '@/components/Modals/Faq.vue'),
            [ModalEnum.IsSafe]: () => import(/* webpackChunkName: "modal.isSafe", webpackPrefetch: true  */ '@/components/Modals/IsSafe.vue'),
            [ModalEnum.WhatOpenBanking]: () => import(/* webpackChunkName: "modal.whatIsOpenBanking", webpackPrefetch: true  */ '@/components/Modals/WhatIsOpenBanking.vue'),
            [ModalEnum.WhoIsAccountScore]: () => import(/* webpackChunkName: "modal.whoIsAccountscore", webpackPrefetch: true  */ '@/components/Modals/WhoIsAccountScore.vue'),
            [ModalEnum.PrivacyPolicy]: () => import(/* webpackChunkName: "modal.policy", webpackPrefetch: true  */ '@/components/Modals/PrivacyPolicy.vue'),
            [ModalEnum.PrivacyNotice]: () => import(/* webpackChunkName: "modal.notice", webpackPrefetch: true  */ '@/components/Modals/PrivacyNotice.vue'),
            [ModalEnum.TermsOfService]: () => import(/* webpackChunkName: "modal.terms", webpackPrefetch: true  */ '@/components/Modals/TermsOfService.vue'),

            [ModalEnum.AboutAccountScore]: () => import(/* webpackChunkName: "modal.aboutAccountScore", webpackPrefetch: true  */ '@/components/Modals/AboutSccountScore.vue'),
            [ModalEnum.ProvidingYourBankDetails]: () => import(/* webpackChunkName: "modal.providingYoubankDetails", webpackPrefetch: true  */ '@/components/Modals/ProvidingYourBankDetails.vue'),
            [ModalEnum.Security]: () => import(/* webpackChunkName: "modal.security", webpackPrefetch: true  */ '@/components/Modals/Security.vue'),
            [ModalEnum.NoCreditImpact]: () => import(/* webpackChunkName: "modal.noCreditImpact", webpackPrefetch: true  */ '@/components/Modals/NoCreditImpact.vue'),
            [ModalEnum.NoBankAlert]: () => import(/* webpackChunkName: "modal.NoBankAlert", webpackPrefetch: true  */ '@/components/Modals/NoBankAlert.vue'),
            
        }, 
        data(): { modal?: ModalEnum } {
            return {
                modal: undefined,
            };
        },
        methods: {
            close() {
                this.modal = undefined;
                this.$emit('close');
                document.body.style.overflow = 'auto';
            },
            openModal(m: ModalEnum) {
                // if the modal is not registered
                if (!(this.$options.components as any)[m]) {
                    return logger.critical(m, ' - Modal not registered');
                }
                this.modal = m;
                document.body.style.overflow = 'hidden';
                this.$emit('open');
            },
        },
        beforeMount() {
            this.$bus.$on(EventEnum.OpenModal, this.openModal);
        },
        beforeDestroy() {
            this.$bus.$off(EventEnum.OpenModal, this.openModal);
        },
    });
